import {
  Box,
  Checkbox,
  Dialog,
  DialogContent,
  InputAdornment,
  Pagination,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { dashboardIcon, region, taskAssign } from "../../config/images";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import {
  addCrops,
  addLiveStocks,
  addTrainingProgramSponsor,
  crops,
  deleteCrops,
  deleteLivestock,
  deleteTrainingProgramSponsor,
  editCrops,
  editLivestock,
  editTrainingProgramSponsor,
  livestocks,
  trainingProgramSponsor,
} from "../../config/services";
import { toast } from "react-toastify";
import { Button } from "../../components/Button/button";

const SponsoredData = () => {
  const navigate = useNavigate("/crops");
  const [editCategory, setEditCategory] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState(false);
  const [addCategory, setAddCategory] = useState(false);
  const [importExcel, setImportExcel] = useState(false);
  const [preview, setPreview] = useState(null);
  const [cropsData, setCropsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [addCategoryData, setAddCategoryData] = useState("");
  const [editCategoryData, setEditCategoryData] = useState("");
  const [editId, setEditId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState();
  const [loading, setIsLoading] = useState(false);

  console.log("currentPagecurrentPage", currentPage);

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };
  const location = useLocation();
  const param = useParams();
  const cropName = location.state?.name;

  const notify = (message) => {
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const notifySuccess = (message) => {
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setPreview(URL.createObjectURL(file)); // Generate preview URL
    }
  };

  useEffect(() => {
    handlegetCropsData();
  }, [currentPage]);

  const handlegetCropsData = async () => {
    try {
      const resp = await trainingProgramSponsor(currentPage, perPage);
      if (resp.status == 200 || resp.status == 201) {
        setCropsData(resp?.data?.results?.payload);
        setCount(resp.data.count);
      }
    } catch (error) {
      setCropsData([]);
    }
  };
  const filteredCrops = cropsData.filter((crop) =>
    crop.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAddData = async (event) => {
    event.preventDefault();
    if (!addCategoryData) {
      notify("Enter Sponsor");
      return;
    }
    const params = {
      name: addCategoryData,
    };
    try {
      setIsLoading(true);
      const resp = await addTrainingProgramSponsor(params);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setAddCategory(false);
        handlegetCropsData();
        setAddCategoryData("");
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      notify(error.response.data.message);
      setAddCategory(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };
  const handleCancel = (e) => {
    if (e) e.preventDefault(); // Prevents default behavior (useful for form buttons)
    setAddCategory(false); // Closes the popup
    setEditCategory(false);
    setAddCategoryData("");
    setDeleteCategory(false);
  };
  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));

  const handleEditPopup = (e) => {
    setEditId(e.id);
    setEditCategory(true);
    setEditCategoryData(e.name);
  };

  const handleEditCategory = async (event) => {
    event.preventDefault();
    if (!editCategoryData) {
      notify("Enter Sponsor");
      return;
    }
    const params = {
      name: editCategoryData,
    };
    try {
      setIsLoading(true);
      const resp = await editTrainingProgramSponsor(params, editId);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setEditCategory(false);
        handlegetCropsData();
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      notify(error.response.data.message);
      setEditCategory(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  const handleDeletePopup = (e) => {
    setEditId(e.id);
    setDeleteCategory(true);
  };

  const handleDeleteDta = async () => {
    try {
      setIsLoading(true);
      const resp = await deleteTrainingProgramSponsor(editId);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
        setDeleteCategory(false);
        handlegetCropsData();
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      notify(error.response.data.message);
      setDeleteCategory(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };
  return (
    <>
      <Box className="task-assign-box">
        <Box className="d-flex justify-content-between align-items-center" style={{flexWrap:"wrap"}}>
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img src={dashboardIcon.sponsoredImgae} alt="" />
            <Typography variant="h6" gutterBottom>
              Who Sponsored
            </Typography>
          </Box>
          <Box className="assign-data-btn">
            <img
              src={region.deleteIcon}
              alt=""
              style={{ marginRight: "10px" }}
              className="delete-btn"
            />
            <button className="deactivate-btn" style={{ marginRight: "10px" }}>
              Demo File
            </button>
            <button
              className="deactivate-btn"
              style={{ marginRight: "10px" }}
              onClick={() => setImportExcel(true)}
            >
              Import Excel
            </button>

            <button
              className="assign-task-btn"
              style={{ marginLeft: "0px" }}
              onClick={() => setAddCategory(true)}
            >
              Add Sponsor
            </button>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "0px 20px",
            boxShadow: "0px 4px 10px rgba(151, 151, 151, 0.12)",
          }}
          className="mt-3 mb-4"
        >
          <TextField
            placeholder="Search here"
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "400",
                    backgroundColor: "#31A05F",
                    height: "100%",
                    padding: "0px",
                    maxHeight: "unset",
                    padding: "0px 15px",
                  }}
                >
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  Search
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <div style={{ height: "520px", overflow: "auto" }}>
          <Table className="region-table pt-3">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "50px" }}>
                  <Checkbox
                    sx={{
                      color: "rgba(225, 230, 244, 1)",
                      borderRadius: "4px",
                      "&.Mui-checked": {
                        color: "rgba(199, 206, 227,1)",
                      },
                    }}
                  />
                </TableCell>
                <TableCell style={{ width: "100px", textAlign: "center" }}>
                  Sr. No
                </TableCell>
                <TableCell>Sponsored Name</TableCell>
                <TableCell style={{ width: "100px" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredCrops?.map((e, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell>
                      <Checkbox
                        sx={{
                          color: "rgba(225, 230, 244, 1)",
                          borderRadius: "4px",
                          "&.Mui-checked": {
                            color: "rgba(199, 206, 227,1)",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {i + 1 + (currentPage - 1) * perPage}
                    </TableCell>
                    <TableCell>{e.name}</TableCell>
                    <TableCell>
                      <div className="d-flex gap-3">
                        <img
                          src={region.editIcon}
                          alt=""
                          onClick={() => handleEditPopup(e)}
                          style={{ cursor: "pointer", height: "23px" }}
                        />
                        <img
                          src={region.deleteIcon}
                          alt=""
                          onClick={() => handleDeletePopup(e)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
        <Box display="flex" justifyContent="end" alignItems="center">
          <Stack spacing={2} className="mb-2">
            <CustomPagination
              count={Math.ceil(count / perPage)}
              page={currentPage}
              onChange={handleChange}
              color="primary"
            />
          </Stack>
        </Box>
        <Dialog
          open={addCategory}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
          // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Add Sponsor
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label="Enter Sponsor"
                name="addCategoryData"
                value={addCategoryData}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 50) {
                    setAddCategoryData(value);
                  }
                }}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button className="cancel-button" onClick={handleCancel}>
                  Cancel
                </button>

                <Button
                  title={"Add Sponsor"}
                  classname={"assign-task-button"}
                  onClick={handleAddData}
                  loading={loading}
                />
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={editCategory}
          onClose={() => setEditCategory(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
          // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Edit Sponsor
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label="Enter Sponsor"
                name="taskTitle"
                value={editCategoryData}
                className="mb-3"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 50) {
                    setEditCategoryData(value);
                  }
                }}
              />

              <div className="d-flex gap-3 mt-2">
                <button className="cancel-button" onClick={handleCancel}>
                  Cancel
                </button>
                <Button
                  title={"Update Sponsor"}
                  classname={"assign-task-button"}
                  onClick={handleEditCategory}
                  loading={loading}
                />
              </div>
            </form>
          </DialogContent>
        </Dialog>

        <Dialog
          open={deleteCategory}
          onClose={() => setDeleteCategory(false)}
          maxWidth="xs"
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <DialogContent className="p-5" style={{ textAlign: "center" }}>
            <Box>
              <img src={region.correct} alt="" />
            </Box>
            <Typography variant="h5" className="pt-4 mb-2">
              <b>Delete this Sponsor </b>
            </Typography>
            <Typography
              variant="p"
              className="pt-4"
              style={{ fontSize: "16px" }}
            >
              Are you sure you want to <br />
              delete this Sponsor{" "}
            </Typography>
            <div className="d-flex gap-3 pt-4">
              <Button
                title={"Yes"}
                classname={"assign-task-button"}
                onClick={handleDeleteDta}
                loading={loading}
              />
              <button className="assign-task-button" onClick={handleCancel}>
                No
              </button>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={importExcel}
          onClose={() => setImportExcel(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
          // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Import Excel
              </h5>
            </div>
          </div>
          <DialogContent>
            {/* <form noValidate autoComplete="off">
                                <TextField
                                  fullWidth
                                  label="Enter Region"
                                  name="taskTitle"
                                  // value={taskData.taskTitle}
                                  // onChange={handleChange}
                                  className="mb-3"
                                />
                  
                                <div className="d-flex gap-3 mt-2">
                                  <button
                                    className="cancel-button"
                                    // onClick={handleSubmit}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="assign-task-button"
                                    // onClick={handleSubmit}
                                  >
                                    Add Region
                                  </button>
                                </div>
                              </form> */}
            <Box textAlign="center">
              <input
                type="file"
                accept="image/*"
                id="file-upload"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <label htmlFor="file-upload">
                <Box
                  sx={{
                    width: "390px",
                    height: "150px",
                    border: "2px dashed #3C4856",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                    boxShadow: "0px 4px 10px rgba(160, 160, 160, 0.16)",
                  }}
                >
                  {preview ? (
                    <img
                      src={preview}
                      alt="Preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img src={region.browseImage} alt="" />
                  )}
                </Box>
              </label>
              <div className="d-flex gap-3 mt-4">
                <button
                  className="cancel-button"
                  onClick={() => setImportExcel(false)}
                >
                  Cancel
                </button>
                <button
                  className="assign-task-button"
                  onClick={() => setImportExcel(false)}
                >
                  Submit
                </button>
              </div>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
};

export default SponsoredData;
